export default __webpack_public_path__ + "static/media/whiteInsta.efbcd9e0.svg";